import classNames from 'classnames';
import './button.less';
import { FC } from 'react';
interface ButtonProps {
  style?: React.CSSProperties;
  className?: string;
  /** 用于a标签跳转 */
  href?: string;
  /** 禁用，置灰且不可点击 */
  disable?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  /** 默认白色按钮，primary:蓝色， success:绿色， error:红色 */
  type?: 'primary' | 'default' | 'error' | 'success';
  [key: string]: any;
}
export const Button: FC<ButtonProps> = ({
  style = {},
  className = '',
  onClick = () => {},
  href = '',
  type = 'default',
  disable = false,
  children,
  ...rest
}) => {
  const cls = classNames('mag-custom-button', type, className, {
    disable,
  });
  return href && !disable ? (
    <a href={href} target="_blank" rel="noreferrer" className={cls} {...rest}>
      {children}
    </a>
  ) : (
    <div
      className={cls}
      style={style}
      onClick={(e) => {
        if (!disable) {
          onClick(e);
        }
      }}
      {...rest}
    >
      {children}
    </div>
  );
};
